export const remoteRepository = 'https://cdn.drp.prod.aws.scania.com/serviceadvisor/microfrontends'

export const localRepository = 'http://localhost:8080'

export const microFrontendManifestService = '/api/microfront-config/microfrontend-manifest'

export const microFrontendMetadataFileName = 'microfrontend-metadata.json'
